import Vue from 'vue'
import router from "@/router/router"
import store from '@/store/store'
import { MessageBox } from 'element-ui';
let that = Vue.prototype
const xin = {
	Toast: (msg_box) => {
		console.log("msg_box", msg_box)
	},
	goUrl: (path,data) => {
		if (router.history.current.path==path || !path) return;
			router.push({path,query: data});
		// store.commit('setactiveIndex', index);
		// store.commit('setclassName', path);
	},
	backPage: () => {
		router.go(-1)
	},
	goNew(url){
		if(!url||url=="#")return;
			window.open(url);
	},
	confirm(data){
		let {msg,title,cancel,confirm,type} = data;
		title = title|| "提示";
		cancel = cancel||'取消';
		confirm = confirm|| "确定";
		type = type|| 'warning';
		return new Promise((req,rej)=>{
			// MessageBox(msg, title, {
			// 	confirmButtonText: confirm,
			// 	cancelButtonText: cancel,
			// 	type
			//   }).then(() => {
			// 	req(1);
			//   }).catch(() => {
			// 	req(0);
			//   });
		});
	},
	getCookie(objName) {//获取指定名称的cookie的值
		var arrStr = document.cookie.split("; ");
		for (var i = 0; i < arrStr.length; i++) {
			var temp = arrStr[i].split("=");
			if (temp[0] == objName) return unescape(temp[1]);  //解码
		}
		return "";
	},
	setCookie(objName, objValue, objHours) {//写Cookie
		var str = objName + "=" + escape(objValue); //编码
		if (objHours > 0) {//为0时不设定过期时间，浏览器关闭时cookie自动消失
			var date = new Date();
			var ms = objHours * 3600 * 1000;
			date.setTime(date.getTime() + ms);
			str += "; expires=" + date.toGMTString();
		}
		document.cookie = str;
	}
}

export default xin
